import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse } from '@angular/common/http';
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import * as moment from 'moment';
import * as _ from 'underscore';

export class PendingRequest {
  url: string;
  method: string;
  options: any;
  data: any;
  params: any;
  subscription: Subject<any>;

  constructor(url: string, method: string, options: any, data: any, params: any, subscription: Subject<any>) {
    this.url = url;
    this.method = method;
    this.options = options;
    this.data = data;
    this.params = params;
    this.subscription = subscription;
  }
}

@Injectable()
export class DataService {
  private requests$ = new Subject<any>();
  private queue: PendingRequest[] = [];

  req: HttpRequest<any>;

  constructor(private httpClient: HttpClient) {
    this.requests$.subscribe((request) => this.execute(request));
  }

  /** Call this method to add your http request to queue */
  invoke(url, method = 'get', params = null, data = null, options = null) {
    return this.addRequestToQueue(url, method, this.parseFilters(params), data, options);
  }

  parseFilters(filters) {
    if (filters) {
      for(const key in filters) {
        // check is date
        if (typeof filters[key] === 'object' && moment(filters[key]).isValid() && _.isDate(filters[key])) {
          filters[key] = moment(filters[key]).format('YYYY-MM-DD');
        }
      }
    }

    return filters;
  }

  clearFilters(filters) {
    const filt = {};
    // tslint:disable-next-line:forin
    for (const key in filters) {
      if (filters[key] !== '' && filters[key] !== null && filters[key] !== undefined) {
        filt[key] = filters[key];
      }
    }
    return filt;
  }

  private execute(requestData) {
    let responseType: 'arraybuffer' | 'blob' | 'json' | 'text' = 'json';
    if (requestData.options && requestData.options.responseType) {
      responseType = requestData.options.responseType;
    }

    this.httpClient
      .request(requestData.method, requestData.url, {
        headers: requestData.options && requestData.options.headers ? requestData.options.headers : null,
        params: this.clearFilters(requestData.params),
        body: requestData.data,
        responseType: responseType
      })
      .subscribe(
        (res) => {
          const sub = requestData.subscription;
          sub.next(res);
          this.queue.shift();
          this.startNextRequest();
        },
        (err) => {
          const sub = requestData.subscription;
          sub.error(err);
          this.queue.shift();
          this.startNextRequest();
        }
      );
  }

  private addRequestToQueue(url, method, params, data, options) {
    const sub = new Subject<any>();
    const request = new PendingRequest(`${environment.api}/${url}`, method, options, data, params, sub);

    this.queue.push(request);
    if (this.queue.length === 1) {
      this.startNextRequest();
    }
    return sub;
  }

  private startNextRequest() {
    // get next request, if any.
    if (this.queue.length > 0) {
      this.execute(this.queue[0]);
    }
  }
}
